<template>
  <div>
    <div @click="clickOpen">
        <svg-icon class-name="international-icon" icon-class="orderSubmit"/>
    </div>
    <order-fill :orderFillDialog="orderFillDialog" :isToolBar="true"/>
  </div>
</template>

<script>
  import OrderFill from '@/components/OrderFill'

export default {
  components:{OrderFill},
    data(){
      return {
        orderFillDialog: false,
      }
    },
    methods: {
      clickOpen() {
          this.orderFillDialog = true;
      }
  }
}
</script>

<style scoped>
.international-icon {
  font-size: 20px;
  cursor: pointer;
  vertical-align: -5px!important;
}
</style>

